import styled from "@emotion/styled";

import { ReactComponent as GarminIcon } from "../../../assets/icons/garmin.svg";
import { ReactComponent as StravaIcon } from "../../../assets/icons/strava.svg";
import GreenButton from "./GreenButton";
import { Button } from "../../../ui/Button/Button";
import {Box} from "@mui/material";

export type ServiceListItemProps = {
    service: string;
    connected: boolean;
    isLoading?: boolean;
    onConnect?: (service: string) => void;
    onDisconnect?: (service: string) => void;
};

const onConnectHandler = (props: ServiceListItemProps) => {
    if (props.isLoading) {
        return;
    }
    if (props.onConnect) {
        props.onConnect(props.service);
    }
}

const onDisconnectHandler = (props: ServiceListItemProps) => {
    if (props.isLoading) {
        return;
    }
    if (props.onDisconnect) {
        props.onDisconnect(props.service);
    }
}

const getIcon = (service: string) => {
    switch (service) {
        case "Garmin":
            return <GarminIcon style={{ width: '205px', height: '47px' }}  />
        case "Strava":
            return <StravaIcon style={{ width: '215px', height: '53px', marginLeft: '-4px' }}  />
        default:
            return service;
    }
}

const getButton = (props: ServiceListItemProps) =>
    props.connected ?
        <GreenButton onClick={() => onDisconnectHandler(props)}>
            <span className="turnon">Подключено</span>
            <span className="turnoff">Отключить</span>
        </GreenButton> :
        <GrayButton buttonType="secondary" onClick={() => onConnectHandler(props)}>Подключить</GrayButton>

export default (props: ServiceListItemProps) => {
    return <SWrapper>
        <div>{getIcon(props.service)}</div>
        <div>
            <Box sx={{ m: 1, position: 'relative' }}>
                {getButton(props)}
            </Box>
        </div>
    </SWrapper>
}

const SWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    margin-bottom: 36px;
    gap: 16px;
`;

const GrayButton = styled(Button)`
    min-width: 127px !important;
`;